import React, { useEffect, useState } from 'react';
import { PlansAPI } from '../../../../api/payments/plans/api';
import { AddonsAPI } from '../../../../api/payments/addons/api';
import {
  CouponScopeLabels,
  CouponValueTypeLabels,
} from '../../../../api/payments/coupons/domain/labels';

function formatDiscountValue(discount) {
  const value = discount.value;
  const valueType = discount.valueType ?? discount.value_type;
  if (value === undefined || value === null || value === '') return '-';
  return valueType === 'PERCENT'
    ? `${value}%`
    : `R$ ${Number(value).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      })}`;
}

const tag = () => (
  <span
    style={{
      display: 'inline-block',
      padding: '4px 10px',
      borderRadius: '6px',
      fontSize: '12px',
      fontWeight: 600,
      color: '#63A311',
      backgroundColor: '#EAF6DC',
    }}
  >
    Ao total
  </span>
);

function getDiscountTargetLabel(discount, plansById, addonsById) {
  const scope = discount.scope;
  if (scope === 'PLAN') {
    if (!discount.planId) return 'Em qualquer plano';
    return plansById[discount.planId] ?? 'Em qualquer plano';
  }
  if (scope === 'ADDON_TOTAL' || scope === 'ADDON_ITEM') {
    if (!discount.addonId) return 'Em qualquer addon';
    return addonsById[discount.addonId] ?? 'Em qualquer addon';
  }
  return tag();
}

export function CouponDiscountsTable({ discounts }) {
  const [plansById, setPlansById] = useState({});
  const [addonsById, setAddonsById] = useState({});

  useEffect(() => {
    const needsPlans = discounts.some((d) => d.scope === 'PLAN');
    const needsAddons = discounts.some(
      (d) => d.scope === 'ADDON_TOTAL' || d.scope === 'ADDON_ITEM',
    );

    if (needsPlans) {
      PlansAPI.list()
        .then((response) => {
          const map = {};
          (response.data.content || []).forEach((plan) => {
            map[plan.id] = plan.name;
          });
          setPlansById(map);
        })
        .catch(() => setPlansById({}));
    }

    if (needsAddons) {
      AddonsAPI.list()
        .then((response) => {
          const map = {};
          (response.data.content || []).forEach((addon) => {
            map[addon.id] = addon.name;
          });
          setAddonsById(map);
        })
        .catch(() => setAddonsById({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discounts]);

  if (discounts.length === 0) {
    return <span className="text-muted">Nenhum desconto configurado</span>;
  }

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <table className="table">
        <thead>
          <tr
            style={{
              color: '#838486',
              fontSize: '12px',
              textTransform: 'uppercase',
            }}
          >
            <th>Aplicado a</th>
            <th>Tipo de desconto</th>
            <th>Valor</th>
            <th>Produto/Plano</th>
          </tr>
        </thead>
        <tbody>
          {discounts.map((discount, index) => (
            <tr key={discount.id ?? index}>
              <td>{CouponScopeLabels[discount.scope] ?? discount.scope}</td>
              <td>
                {CouponValueTypeLabels[discount.valueType ?? discount.value_type] ??
                  discount.valueType ??
                  discount.value_type}
              </td>
              <td>{formatDiscountValue(discount)}</td>
              <td>{getDiscountTargetLabel(discount, plansById, addonsById)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
